import "./PurchaseStoragePlanPopup.css";

/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import {
  getStorageData,
  getStoragePlans,
} from "Config/API/get";
import { useDispatch, useSelector } from "react-redux";

import InfoPopup from "../InfoPopup/InfoPopup";
import StripeOnboardingRequiredPopup from "Components/Popup/StripeOnboardingRequiredPopup/StripeOnboardingRequiredPopup";
import { getOrganizationStorageDataAction } from "Redux/action/get.action";
import useStripeOnboardingGuard from "Hooks/useStripeOnboardingGuard";
import { purchaseStoragePlan } from "Config/API/action";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const PurchaseStoragePlanPopup = ({
  hide,
  totalStorageUsedInGb,
  selectedPlanId,
  token,
  defaultCardDetails,
  setLoader,
  resetLoader,
  buttonText,
  from,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showInfoPopup, setShowInfoPopup] = useState(false);
  const [showStripeOnboardingPopup, setShowStripeOnboardingPopup] =
    useState(false);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [selectedPlanDetails, setSelectedPlanDetails] = useState({});
  const [selectedPlanUniqueId, setSelectedPlanUniqueId] =
    useState(selectedPlanId);
  const usableCredit = useSelector(
    (state) => state.getUsableCreditBalanceReducer
  );
  const { isOnboardingRequired, stripeDashboardUrl } =
    useStripeOnboardingGuard();

  const [allStoragePlans, setAllStoragePlans] = useState([]);

  const pageLoadingArray = ["", "", "", "", "", ""];

  useEffect(() => {
    getAllStoragePlans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAllStoragePlans = () => {
    setIsPageLoading(true);
    const storagePlansApiResponse = getStoragePlans(token);
    storagePlansApiResponse.then((res) => {
      setIsPageLoading(false);
      if (res?.data?.status) {
        setAllStoragePlans(res?.data?.data);
      } else toast(res?.data?.message, { type: "error" });
    });
  };

  const handleProceedButtonClick = () => {
    if (isOnboardingRequired) {
      toast("Complete Stripe onboarding before upgrading storage.", {
        type: "info",
      });
      setShowStripeOnboardingPopup(true);
      return;
    }
    if (selectedPlanId === selectedPlanUniqueId) return;
    if (Number(selectedPlanDetails?.rate) > Number(usableCredit))
      return toast("You do not have enough Balance", { type: "info" });
    setLoader();
    const upgradePlanApiResponse = purchaseStoragePlan(
      token,
      selectedPlanUniqueId
    );
    upgradePlanApiResponse.then((res) => {
      if (res?.status) {
        const apiResponse = getStorageData(token, "");
        apiResponse.then((response) => {
          resetLoader();
          if (response?.data?.status) {
            hide(false);
            toast(res?.message, { type: "success" });
            dispatch(getOrganizationStorageDataAction(response?.data?.data));
          } else toast(response?.message, { type: "error" });
        });
      } else {
        resetLoader();
        toast(res?.message, { type: "error" });
      }
    });
  };

  return (
    <>
      <div className="purchase-storage-plan-parent">
        <div className="purchase-storage-plan-main">
          <div className="purchase-storage-plan-heading">
            <p>Upgrade Plan</p>
            {from !== "renewCloudSubscription" && (
              <div className="rename-cross" onClick={() => hide(false)}>
                X
              </div>
            )}
          </div>
          <div className="purchase-storage-plan-body">
            <div className="purchase-storage-plan-wrapper">
              {!isPageLoading
                ? allStoragePlans?.map((item) => {
                    return (
                      <div
                        className="purchase-storage-plan-wrapper-content"
                        onClick={() => {
                          setSelectedPlanDetails(item);
                          if (item?.toSize < totalStorageUsedInGb) {
                            return setShowInfoPopup(true);
                          }
                          setSelectedPlanUniqueId(item?.id);
                        }}
                      >
                        <label>{item?.storageName}</label>
                        <button
                          className="purchase-storage-plan-wrapper-content-card"
                          style={{
                            border:
                              item?.id === selectedPlanUniqueId &&
                              "2px solid #5CA127",
                          }}
                        >
                          <input
                            type="radio"
                            checked={item?.id === selectedPlanUniqueId}
                          />
                          <div className="purchase-storage-plan-wrapper-content-card-labels">
                            <label>
                              {item?.fromSize === 0
                                ? `${item?.toSize} GB`
                                : item?.fromSize === 500
                                ? `${item?.fromSize} GB+`
                                : `${item?.fromSize} - ${item?.toSize} GB`}
                            </label>
                            <span>
                              {item?.slug === "free"
                                ? "FREE"
                                : `${(+item?.rate)?.toFixed(2)}/month`}
                            </span>
                          </div>
                        </button>
                      </div>
                    );
                  })
                : pageLoadingArray?.map((item, index) => {
                    return (
                      <div className="purchase-storage-plan-wrapper-content">
                        <label
                          className="animation"
                          style={{ height: "19px", width: "65px" }}
                        />
                        <div
                          className="animation"
                          style={{
                            marginTop: "5px",
                            height: "70px",
                            width: index === 0 ? "135px" : "197px",
                          }}
                        />
                      </div>
                    );
                  })}
            </div>
            <div
              className="default-payment-wrapper"
              style={{ paddingBottom: "0px" }}
            >
              <button
                onClick={() => {
                  if (isPageLoading) return;
                  handleProceedButtonClick();
                }}
                className="upgrade-plan-proceed-button"
              >
                {buttonText}
              </button>
            </div>
          </div>
        </div>
      </div>
      {showInfoPopup && (
        <InfoPopup
          hide={setShowInfoPopup}
          header="Downgrade Storage Plan"
          description={`You have used ${totalStorageUsedInGb?.toFixed(
            2
          )}Gb Storage. The Plan you are trying to select has an upper limit of ${selectedPlanDetails?.toSize?.toFixed(
            2
          )}Gb. To Continue try deleting ${(
            totalStorageUsedInGb - selectedPlanDetails?.toSize
          ).toFixed(2)}Gb of you stored data.`}
        />
      )}
      {showStripeOnboardingPopup && (
        <StripeOnboardingRequiredPopup
          hide={setShowStripeOnboardingPopup}
          dashboardUrl={stripeDashboardUrl}
        />
      )}
    </>
  );
};

export default PurchaseStoragePlanPopup;
